import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { ClientType, DocumentType, GetClientByDocumentUseCase } from '../../../core';

export const isClientNatural = (
    required: boolean,
    docType: DocumentType,
    getClientByDocumentUseCase: GetClientByDocumentUseCase
): AsyncValidatorFn => {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
        const v: string = control.value;

        if (!required) {
            return of(null);
        }

        return getClientByDocumentUseCase.bind({ docType, docId: v }).pipe(
            debounceTime(400),
            distinctUntilChanged(),
            map((transaction) => {
                return transaction.isSuccess && transaction.data.type !== ClientType.NATURAL_PERSON ? { isClientNatural: true } : null;
            })
        );
    };
};
